import { valueMatchesKind } from './value-matches-kind.js';
/** `isEmpty`/`isSet` take no comparison value; `in` expects an array whose members match the field's kind. */
export function conditionValueMatchesOperator(operator, value, kind) {
    if (operator === 'isEmpty' || operator === 'isSet')
        return value === undefined;
    if (operator === 'in')
        return (Array.isArray(value) &&
            value.length > 0 &&
            value.every((item) => valueMatchesKind(item, kind)));
    return valueMatchesKind(value, kind);
}
//# sourceMappingURL=condition-value-matches-operator.js.map